<div
  class="card mb-4 {{ fillFullHeightOfParent ? 'h-100' : '' }}"
  [id]="id"
  [attr.data-sidenav-label]="sidenavLabel"
>
  <div
    class="{{ folded ? 'card-body' : 'card-header' }}
    {{ !addMarginBottomHeader && !folded ? 'pb-0' : hasIntro && !folded ? 'pb-1' : '' }} {{
      titleSize == 5 && youtubeUrl
        ? 'align-items-center'
        : centerTitle
          ? 'text-center'
          : 'd-flex justify-content-between'
    }}"
  >
    <div class="{{ titleSize == 5 && youtubeUrl ? 'd-flex justify-content-between' : 'd-flex' }}">
      <a (click)="folded = !folded" *ngIf="foldable" class="pe-2">
        <i
          class="fa-solid {{
            folded ? 'fa-circle-chevron-right' : 'fa-circle-chevron-down'
          }} text-secondary"
          title="'{{ title }}' toeklappen"
          style="padding-top: 6px"
        ></i>
      </a>
      <ng-content select="[card-title]"> </ng-content>
      <h5 *ngIf="titleSize == 5">{{ title }}</h5>
      <h4 *ngIf="titleSize == 4">{{ title }}</h4>
      <h3 *ngIf="titleSize == 3">{{ title }}</h3>
      <h2 *ngIf="titleSize == 2">{{ title }}</h2>
      <h1 *ngIf="titleSize == 1">{{ title }}</h1>
      <div *ngIf="titleSize == 5 && youtubeUrl">
        <h6 class="mb-0">
          <a [href]="youtubeUrl" target="_blank">
            <i class="fa-brands fa-youtube me-1 fs-5 align-text-bottom" style="color: #ff0000"></i>
            Bekijk webinar
          </a>
        </h6>
      </div>
    </div>
    <ng-content select="[card-header]"> </ng-content>
  </div>

  <div
    class="card-body pt-0 {{ !addXPaddingBody ? 'px-0' : '' }} {{ addPaddingFooter ? '' : 'pb-0' }}"
    *ngIf="!foldable || !folded"
  >
    <ng-content></ng-content>
  </div>
  <div
    #footerBlock
    class="{{ showFooter ? 'card-footer' : '' }} {{ addPaddingFooter ? '' : 'pt-0' }}"
  >
    <ng-content *ngIf="showFooter" select="[footer]"></ng-content>
  </div>
</div>
